import React from "react";
import PropTypes from "prop-types";
import Slider from "@mui/material/Slider";
import useStyles from "./styles";
import noop from "../../../services/noop";

const NumberInputSlider = (props) => {
  const styles = useStyles(props);

  const sliderChangeHandler = (evnt, newValue) => {
    props.setError("");
    props.setValue(parseFloat(newValue));
  };

  const { labels } = props;
  const isLabelsPresent =
    labels && (labels.left || labels.center || labels.right) ? true : false;
  const leftLabel = labels && labels.left ? labels.left : "";
  const centerLabel = labels && labels.center ? labels.center : "";
  const rightLabel = labels && labels.right ? labels.right : "";

  return (
    <>
      <div className={styles.sliderLabels}>
        <span className={styles.leftLabel}>
          {isLabelsPresent ? leftLabel : props.min}
        </span>
        {isLabelsPresent && centerLabel && (
          <span className={styles.centerLabel}>{centerLabel}</span>
        )}
        <span className={styles.rightLabel}>
          {isLabelsPresent ? rightLabel : props.max}
        </span>
      </div>
      <Slider
        data-testid="slider"
        min={props.min}
        max={props.max}
        step={props.stepSize}
        value={props.value === "" ? props.min : props.value}
        onChange={sliderChangeHandler}
        aria-labelledby="continuous-slider"
        classes={{
          rail: styles.rail,
          track: styles.track,
          thumb: styles.thumb,
        }}
      />
    </>
  );
};

NumberInputSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  stepSize: PropTypes.number.isRequired,
  labels: PropTypes.object,
  setValue: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired,
  setError: PropTypes.func.isRequired,
};

NumberInputSlider.defaultProps = {
  min: 0,
  max: 100,
  stepSize: 1,
  setValue: noop,
  value: "",
  setError: noop,
};

export default NumberInputSlider;
